"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_HUBCALLBACK_PROVIDED_EXCEPTION = exports.USER_AGENT_HEADER = exports.AWS_CLOUDWATCH_CATEGORY = void 0;
// Logging constants
exports.AWS_CLOUDWATCH_CATEGORY = 'Logging';
exports.USER_AGENT_HEADER = 'x-amz-user-agent';
// Error exception code constants
exports.NO_HUBCALLBACK_PROVIDED_EXCEPTION = 'NoHubcallbackProvidedException';
